/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProjectChapterType {

    PROJECT_SETUP = 'PROJECT_SETUP',

    PRINCIPLE_DEFINITION = 'PRINCIPLE_DEFINITION',

    ACTUAL_SYSTEMS = 'ACTUAL_SYSTEMS',

    EVALUATION_CRITERIA = 'EVALUATION_CRITERIA',

    RFI = 'RFI',

    RFP = 'RFP',

    RFD = 'RFD',

    RFQ = 'RFQ',

    OVERALL_RESULT = 'OVERALL_RESULT',

    DECISION_REPORT = 'DECISION_REPORT',

    NOT_IMPLEMENTED = 'NOT_IMPLEMENTED'
}

